import React from 'react';
import { Link } from 'react-router-dom'
import TextField from 'material-ui/TextField';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';

import {Row,Col} from 'react-bootstrap'
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import CircularProgress from 'material-ui/CircularProgress';
import Checkbox from 'material-ui/Checkbox';
import _ from 'lodash';

import * as actions from '../../../Actions/index.js';
import { connect } from 'react-redux';

class TeamStep extends React.Component{
    constructor(props){
        super(props);
        this.InformationToggle = this.InformationToggle.bind(this);
        this.state = {
            information: 'deactivate-information',
            value1: 2,
            value2: 2,
            value3: 2,
            memberEmail1: '',
            memberEmail2: '',
            memberEmail3: '',
            memberName1: '',
            memberName2: '',
            memberName3: '',
            buttonDisable: false,
            allManuals : { 'COVER': true},
            selectManual: ''
          };
        this.addCompanyTeamMember= this.addCompanyTeamMember.bind(this);
        this.toggleIncludeManual = this.toggleIncludeManual.bind(this);
    }
	handleChange1 = (event, index, value) => this.setState({value1:value});
    handleChange2 = (event, index, value) => this.setState({value2:value});
    handleChange3 = (event, index, value) => this.setState({value3:value});
    InformationToggle(){
     let value =  (this.state.information === 'deactivate-information') ? 'active-information' : 'deactivate-information' 
        this.setState({ information : value });
    }
    componentDidMount(){
        this.props.fetchManuals(0);
    }
    componentWillReceiveProps(nextProps){   
        let checkButtonstatus=nextProps.signUp.disableButtonTeamStatus;
        this.setState({buttonDisable:checkButtonstatus});
    }
    // add team member form
    addCompanyTeamMember(e){
        e.preventDefault();
        var companyId=this.props.signUp.signupUser ? this.props.signUp.signupUser.company._id : '';
        let selectedManual = document.companyteam.manualSelect.value;
        var updatedManualsList = this.state.allManuals;
        if(selectedManual != ''){
            updatedManualsList[selectedManual] = true;
        }
        //this.setState({allManuals:updatedManualsList});
        // _.forEach(updatedManualsList,function(ischeck,manualName){
        //     console.log(ischeck +' and ' + manualName)
        //     if(!ischeck){
        //         delete updatedManualsList[manualName]
        //     }
        // })
        // console.log('updatedManualsList',updatedManualsList);
        let manualLength = _.keys(updatedManualsList)
        if(companyId && manualLength.length > 1){
            this.props.addSelectedManual(companyId,updatedManualsList);
            this.setState({selectManual : ''})
        }else{
            this.setState({selectManual : 'Please select any manual type to proceed.'})
        }
    }
    toggleIncludeManual(e,groupName){
        let allManuals = this.state.allManuals;
        allManuals[groupName] = e.target.checked;
        this.setState({allManuals:allManuals});
    }
    listsManual(){
        let manaulGroups = this.state.allManuals ;
        // console.log('this.props.templates',this.props.templates.items);
        let manuals = _.groupBy(this.props.templates.items,'category');
        manuals = _.omit(manuals, ['COVER']);
        manuals = _(manuals).toPairs().sortBy(0).fromPairs().value()
        let renderManuals = _.map(manuals,(group,groupName)=>{
            return(
                <RadioButton
                  value={groupName}
                  label={groupName}
                />
                );
        });
        return renderManuals;
    }
	render() {
        var companyId=this.props.signUp.signupUser ? this.props.signUp.signupUser.company._id : '';
        if(!companyId){
           companyId= window.localStorage.getItem('temp_company_id');
        //    console.log('company id', companyId);
        }
        let listsManual = this.listsManual();
	  	return(<div>
                    <div className="signup-page">
                        <div className="signup-left col-6">
                            <div className="show-information vissible-sm vissible-xs"  onClick={this.InformationToggle}>
                                <i className="zmdi zmdi-info"></i>
                            </div>
                            <div className="signup-form-section">
                                <div className="logo-dokkit">
                                    <figure>
                                        <Link to="#">
                                            <img src="/images/dokkit-logo.png" alt="logo" />
                                        </Link>
                                    </figure>
                                </div>
                                <form name="companyteam" onSubmit={this.addCompanyTeamMember}>
                                    <h3>Choose your O&M Manuals</h3>
                                    <p>Please select your main O&M manual –additional ones can be added in the webapp</p>
                                    <div className="audio-visual-list">
                                        <Row>
                                            <Col xs={12}>
                                                <h2 style={{color: 'red', padding: "10px 0px"}}>{this.state.selectManual}</h2>
                                            </Col>
                                            <Col xs={12}>
                                                <ul className="radio-btn-custom">
                                                    <RadioButtonGroup name="manualSelect">
                                                        {listsManual}
                                                    </RadioButtonGroup> 
                                                </ul>
                                            </Col>
                                        </Row>
                                    </div>
                                    <Row>
                                        <Col xs={12}>
            	                            <RaisedButton label={this.state.buttonDisable? <CircularProgress size={32} color="#fff"/> :"Continue"} type="submit" labelColor="#fff" fullWidth={true} disabled={!this.state.buttonDisable?false:true}/>
                                        </Col>
                                    </Row>                                
                                </form>
                            </div>

                            <div className="tab-navigation">
                                <ul>
                                    <li>
                                        <Link to="#">
                                            <span>1</span> Company Setup
                                        </Link>
                                    </li>
                                     <li className="active">
                                        <Link to="team-setup">
                                            <span>2</span> O&M Setup
                                        </Link>
                                    </li>
                                     <li>
                                        <Link to={"#"}>
                                            <span>3</span> Integration information
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className={`signup-right col-6 display-flex ${this.state.information}`}>
                            <div className="right-content margin-auto">
                                <h3>Hey there!</h3>
                                <p>only one more step to go.</p>
                                <figure>
                                    <img src="/images/teamsetup.png" alt="vector" />
                                </figure>
                                <div className="featured-list">
                                    <h4>Feature Tip:</h4>
                                    <p>Within the app, help pages are available detailing different style examples of the front pages for the O&M manuals. You can download a new one there, update it with your own details, colours etc. and upload it to your account in the webapp. </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>		
		  )
    }
}
const mapStateToProps= (state,props)=> {
    return {
      signUp : state.signup,
      templates: state.templates,
    };
}
export default connect(mapStateToProps,actions)(TeamStep);



// WEBPACK FOOTER //
// ./src/Components/Modules/LoginSignup/TeamStep.js